import { FC, useEffect, useMemo, useState } from "react";
import { BillingsPlanEntryRelatedCargoTaxiItem } from "../../../../../../common/services/billings/plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi";
import { useAppContext } from "../../../../../../context/app.context";
import useBillingsPlanEntryRelatedCargoTaxi from "../../../../../../common/services/billings/plan-entry/related/cargo-taxi/use-billings-plan-entry-related-cargo-taxi";
import useAbort from "../../../../../../common/hooks/use-abort";
import CardComponent from "../../../../../../common/components/card/card.component";
import billingsTranslationsHelper from "../../../../../../languages/billings-translations.helper";
import RelatedBillingsCargoTaxiTableRow from "../../../../common/related-billings/cargo-taxi/types/related-billings-cargo-taxi-table-row";
import relatedBillingsCargoTaxiFactory from "./related-billings-cargo-taxi.factory";
import RelatedBillingsCargoTaxiTableComponent from "../../../../common/related-billings/cargo-taxi/related-billings-cargo-taxi-table.component";

type RelatedBillingsCargoTaxiProps = {
  planEntryId: string | undefined;
};

const RelatedBillingsCargoTaxiComponent: FC<RelatedBillingsCargoTaxiProps> = (
  props,
) => {
  const translations =
    billingsTranslationsHelper.getBillingsTranslations().relatedBillings
      .cargo_taxi;

  const [relatedBillingsCargoTaxiData, setRelatedBillingsCargoTaxiData] =
    useState<BillingsPlanEntryRelatedCargoTaxiItem[]>([]);

  const { selectedAppLanguage } = useAppContext();
  const cargoTaxi = useBillingsPlanEntryRelatedCargoTaxi();
  const cargoTaxiAbort = useAbort();

  const cargoTaxiData = async () => {
    cargoTaxi.load(
      { planEntryUuid: props.planEntryId! },
      cargoTaxiAbort.signal,
    );
  };

  useEffect(() => {
    if (!props.planEntryId) return;

    cargoTaxiData();
  }, [props.planEntryId]);

  useEffect(() => {
    if (!cargoTaxi.data.data) return;

    setRelatedBillingsCargoTaxiData(cargoTaxi.data.data);
  }, [cargoTaxi.data.data]);

  const tableRows: RelatedBillingsCargoTaxiTableRow[] = useMemo(() => {
    if (!relatedBillingsCargoTaxiData) return [];

    return relatedBillingsCargoTaxiFactory.createTableRows(
      relatedBillingsCargoTaxiData,
    );
  }, [relatedBillingsCargoTaxiData, selectedAppLanguage]);

  return (
    <CardComponent
      classNames={{ root: "related_order_billings" }}
      header={{ title: translations.summaryLabel }}
    >
      <RelatedBillingsCargoTaxiTableComponent
        tableRows={tableRows}
        isLoading={cargoTaxi.isLoading && !!props.planEntryId}
      />
    </CardComponent>
  );
};

export default RelatedBillingsCargoTaxiComponent;
